import { memo } from "react";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { pickingRoutes } from "../../../../router/routesConstants";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";

import { TableItemType } from "../../../../components/tables/tableContext/TableContext";

function OrdersByDayTableActionButtons({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}) {
  const goToDeliveryArrangement = () => {
    return `/${pickingRoutes.picking}/${pickingRoutes.deliveryArrangement}?ruta=${crudData?.ruta}`;
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData?.ruta}
      ariaLabel={`Actiuni pentru ruta ${crudData?.ruta ?? ""}`}
      items={[
        {
          id: "delivery-arrangements",
          label: "Dispozitii de livrare",
          icon: "SPLIT_LIST",
          tooltip: "Deschide dispozitiile de livrare pentru aceasta ruta.",
          navigate: goToDeliveryArrangement(),
        },
      ]}
    />
  );
}

export default memo(OrdersByDayTableActionButtons);
